export default __webpack_public_path__ + "static/design-605dafa249ca66d45972df2e841f9d16.png";